import { type CollectionConfig, CollectionLayout, CollectionSlug } from '../collections.types';

/**
 * The original May-4th campaign page, moved verbatim out of the hardcoded branches it used to
 * live in. `CollectionLayout.LegacyPromo` freezes its appearance; `searchParams.keyword`
 * reproduces what the old slug-as-keyword code produced (the literal hyphenated slug, which is
 * what search-party has always received); no `seoTitle`/`metaDescription` so it keeps its derived
 * `Bid on "Star Wars" - N auction listings` title. Tile images stay on the item CDN, as today.
 */
export const starWarsCollection: CollectionConfig = {
    breadcrumbs: [
        { href: '/c/collectibles/', label: 'Collectibles' },
        { href: '', label: 'Star Wars' },
    ],
    description: 'Do. Or do not. There is no try—only bid! Secure your Star Wars grails today.',
    layout: CollectionLayout.LegacyPromo,
    searchParams: { keyword: CollectionSlug.StarWars },
    slug: CollectionSlug.StarWars,
    subcategories: [
        {
            href: '/search/?keyword=star%20wars%20signed',
            imageUrl: 'https://p1.liveauctioneers.com/7804/368859/202891577_1_x.jpg',
            title: 'Signed Collectables',
        },
        {
            href: '/search/?keyword=star%20wars%20figurine&sort=-relevance&status=online',
            imageUrl: 'https://p1.liveauctioneers.com/6629/366363/201403558_1_x.jpg',
            title: 'Figures & Figurines',
        },
        {
            href: '/search/?category_id=24&keyword=star%20wars%20coin&sort=-relevance&status=online',
            imageUrl: 'https://p1.liveauctioneers.com/6899/367399/203001757_1_x.jpg',
            title: 'Coins',
        },
        {
            href: '/search/?keyword=star%20wars%20card&sort=-relevance&status=online',
            imageUrl: 'https://p1.liveauctioneers.com/7804/368983/203016821_1_x.jpg',
            title: 'Trading Cards ',
        },
        {
            href: '/search/?category_id=14777&keyword=star%20wars&sort=-relevance&status=online',
            imageUrl: 'https://p1.liveauctioneers.com/3780/369225/203217637_1_x.jpg',
            title: 'LEGO',
        },
        {
            href: '/search/?category_id=6&keyword=star%20wars&sort=-relevance&status=online',
            imageUrl: 'https://p1.liveauctioneers.com/3780/368953/202993661_1_x.jpg',
            title: 'Watches & Jewelry',
        },
    ],
    subcategoriesHeading: 'Discover More From the Galaxy',
    title: 'May the Fourth Be With Your Bids',
};
